import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
const SortedProductLines = ['MARKETING', 'SALES', 'SERVICE', 'CMS', 'OPERATIONS', 'COMMERCE'];
const SortedProductLevels = ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'];
export const sortProductLines = productLines => {
  const copy = [...productLines];
  copy.sort((a, b) => {
    return SortedProductLines.indexOf(a) - SortedProductLines.indexOf(b);
  });
  return copy;
};
export const sortApiNamesByProductLevel = apiNames => {
  const copy = [...apiNames];
  copy.sort((a, b) => {
    return SortedProductLevels.indexOf(getProductLevelFromApiNameString(a)) - SortedProductLevels.indexOf(getProductLevelFromApiNameString(b));
  });
  return copy;
};